import React, { useState, useEffect, useContext } from 'react';
import StateContext from '../../helpers/ContextState';
import { PostAsync, format } from '../../helpers/Functions';
import Config from '../../helpers/Config';
import Input from '../../components/InputSimple';

const CASO_STYLES = {
  pagado:         {},
  pendiente_pago: { borderLeft: '3px solid #0652DD' },
};

const getParamsFromUrl = () => {
  const parts = window.location.pathname.split('/').filter(Boolean);
  return {
    proveedor_id:           parts[3] || '',
    op_inventario_items_id: parts[4] || '',
    semestre:               parts[5] || '',
    anio:                   parts[6] || '',
  };
};

const emptyTds = (n) => Array.from({ length: n }).map((_, i) => <td key={i}></td>);

const COLS = 16;

const App = () => {
  const context = useContext(StateContext);

  const [proveedor, setProveedor]                 = useState(null);
  const [comprasPagadas, setComprasPagadas]       = useState([]);
  const [comprasPendientes, setComprasPendientes] = useState([]);
  const [totales, setTotales]                     = useState({});
  const [valorUnitario, setValorUnitario]         = useState(0);
  const [loading, setLoading]                     = useState(true);

  const [inputs, setInputs] = useState({ fecha_inicio: '', fecha_fin: '' });

  const onChangeCustom = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => { getInit(); }, [inputs]);

  const getInit = () => {
    const p = getParamsFromUrl();

    if (!p.proveedor_id || !p.op_inventario_items_id) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setComprasPagadas([]);
    setComprasPendientes([]);

    PostAsync('Informes', 'ListadoRebateDetalle', { ...p, ...inputs }, context).then((res) => {
      setLoading(false);
      if (!res || res.error) return;
      if (res.proveedor)                    setProveedor(res.proveedor);
      if (res.compras_pagadas)              setComprasPagadas(res.compras_pagadas);
      if (res.compras_pendientes)           setComprasPendientes(res.compras_pendientes);
      if (res.totales)                      setTotales(res.totales);
      if (res.valor_unitario !== undefined) setValorUnitario(res.valor_unitario);
    });
  };

  const p = getParamsFromUrl();

  const pdfBaseUrl = Config.ConfigApirest
    + 'PDF/Informes/ListadoRebateDetalle/' + context.user.token;

  const excelBaseUrl = Config.ConfigApirest
    + 'Excel/Informes/ListadoRebateDetalleExcel'
    + '/proveedor_id:'           + p.proveedor_id
    + '/op_inventario_items_id:' + p.op_inventario_items_id
    + '/semestre:'               + p.semestre
    + '/anio:'                   + p.anio
    + '/token:'                  + context.user.token;

  const openPdf = (e) => {
    e.preventDefault();
    const uri = e.target.href
      + '?proveedor_id='           + p.proveedor_id
      + '&op_inventario_items_id=' + p.op_inventario_items_id
      + '&semestre='               + p.semestre
      + '&anio='                   + p.anio
      + '&fecha_inicio='           + inputs.fecha_inicio
      + '&fecha_fin='              + inputs.fecha_fin;
    window.open(uri);
  };

  const openExcel = (e) => {
    e.preventDefault();
    const uri = e.target.href
      + '?semestre='     + p.semestre
      + '&anio='         + p.anio
      + '&fecha_inicio=' + inputs.fecha_inicio
      + '&fecha_fin='    + inputs.fecha_fin;
    window.open(uri);
  };

  const proveedorNombre = proveedor
    ? (proveedor.ma_naturaleza_id == 1
        ? proveedor.nombres + ' ' + proveedor.apellidos
        : proveedor.nombres)
    : '';
  
  const totCantidadPag   = comprasPagadas.reduce((s, r)    => s + parseFloat(r.cantidad || 0), 0);
  const totCantidadPend  = comprasPendientes.reduce((s, r) => s + parseFloat(r.cantidad || 0), 0);
  const totKilosPag      = comprasPagadas.reduce((s, r)    => s + parseFloat(r.peso     || 0), 0);
  const totKilosPend     = comprasPendientes.reduce((s, r) => s + parseFloat(r.peso     || 0), 0);
  const totSubPag        = comprasPagadas.reduce((s, r)    => s + parseFloat(r.subtotal_calc || 0), 0);
  const totSubPend       = comprasPendientes.reduce((s, r) => s + parseFloat(r.subtotal_calc || 0), 0);
  const totIvaPag        = comprasPagadas.reduce((s, r)    => s + parseFloat(r.iva_total || 0), 0);
  const totIvaPend       = comprasPendientes.reduce((s, r) => s + parseFloat(r.iva_total || 0), 0);
  const totReteivaPag    = comprasPagadas.reduce((s, r)    => s + parseFloat(r.reteiva_total || 0), 0);
  const totReteivaPend   = comprasPendientes.reduce((s, r) => s + parseFloat(r.reteiva_total || 0), 0);
  const totReteicaPag    = comprasPagadas.reduce((s, r)    => s + parseFloat(r.reteica_total || 0), 0);
  const totReteicaPend   = comprasPendientes.reduce((s, r) => s + parseFloat(r.reteica_total || 0), 0);
  const totRefuentePag   = comprasPagadas.reduce((s, r)    => s + parseFloat(r.retefuente_total || 0), 0);
  const totRefuentePend  = comprasPendientes.reduce((s, r) => s + parseFloat(r.retefuente_total || 0), 0);
  const totRebPag        = comprasPagadas.reduce((s, r)    => s + parseFloat(r.rebate_valor || 0), 0);
  const totRebPend       = comprasPendientes.reduce((s, r) => s + parseFloat(r.rebate_valor || 0), 0);
  const totTotalPag      = comprasPagadas.reduce((s, r)    => s + parseFloat(r.precio_total_rebate || 0), 0);
  const totTotalPend     = comprasPendientes.reduce((s, r) => s + parseFloat(r.precio_total_rebate || 0), 0);

  const renderFila = (row, idx) => {
    const estilo = CASO_STYLES[row.caso] || {};
    const obs    = row.observacion && row.observacion.trim()
      ? row.observacion.length > 30
        ? row.observacion.substr(0, 30) + '...'
        : row.observacion
      : '';
    return (
      <tr key={idx} style={estilo}>
        <td className="text-center small">{row.consecutive}</td>
        <td className="text-center small">{row.fecha_recibido_string}</td>
        <td className="text-end small">{row.cantidad_format}</td>
        <td className="text-end small">{row.peso_format}</td>
        <td className="text-end small">{row.precio_format}</td>
        <td className="text-end small">{row.subtotal_format}</td>
        <td className="text-end small">{row.iva_total_string}</td>
        <td className="text-end small">{row.calculo_reteiva}</td>
        <td className="text-end small">{row.calculo_reteica}</td>
        <td className="text-end small">{row.calculo_retefuente}</td>
        <td className="text-end small">{format(valorUnitario)}</td>
        <td className="text-end small"><b>{row.rebate_format}</b></td>
        <td className="text-end small">{row.promedio_piel_kilos_format}</td>
        <td className="text-end small"><b>{row.precio_total_rebate_string}</b></td>
        <td className="small">{row.marca}</td>
        <td className="small" title={row.observacion || ''}>{obs}</td>
      </tr>
    );
  };

  return (
    <div className="container-fluid" style={{ marginTop: '60px' }}>

      {proveedor && (
        <div className="row justify-content-center mb-2">
          <b className="h5 text-center">
            <strong>Proveedor:</strong> {proveedorNombre}
          </b>
          <b className="h6 text-center mb-1">
            <strong>NIT:</strong> {proveedor.nro_documento}
            &nbsp;&nbsp;
            <strong>Vr. Unitario Rebate:</strong> ${format(valorUnitario)} / kg
          </b>
        </div>
      )}

      <div className="row bg-gray small">
        <div className="col-12 small">
          <b>Filtros por fecha de compra</b>
        </div>
        <div className="col-12 col-sm-2 mb-3 pt-1 text-left">
          <Input
            defaultValue={inputs.fecha_inicio}
            title="Fecha desde"
            placeholder="Fecha desde"
            type="date"
            name="fecha_inicio"
            className="form-control"
            onChange={onChangeCustom}
          />
        </div>
        <div className="col-12 col-sm-2 mb-3 pt-1 text-left">
          <Input
            defaultValue={inputs.fecha_fin}
            title="Fecha hasta"
            placeholder="Fecha hasta"
            type="date"
            name="fecha_fin"
            className="form-control"
            onChange={onChangeCustom}
          />
        </div>
        <div className="col-12 col-sm-2 mb-3 pt-1 text-left border-start">
          <label className="form-label small">&nbsp;</label>
          <div>
            <a className="btn btn-primary me-1" href={pdfBaseUrl} target="_blank" onClick={openPdf}>PDF</a>
            <a className="btn btn-primary" href={excelBaseUrl} target="_blank" onClick={openExcel}>Excel</a>
          </div>
        </div>
      </div>

      <div className="row mt-2 mb-1">
        <div className="col small text-muted">
          <span style={{ borderLeft: '3px solid #0652DD', paddingLeft: '6px', marginRight: '12px' }}>
            Pendiente de pago
          </span>
          <span style={{ paddingLeft: '6px' }}>
            Sin borde = Pagada
          </span>
        </div>
      </div>

      <div className="row">
        <div className="col">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-secondary" role="status" />
            </div>
          ) : !p.proveedor_id || !p.op_inventario_items_id ? (
            <div className="alert alert-warning mt-3">Parámetros de URL incorrectos.</div>
          ) : (
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="col text-center small">#</th>
                  <th className="col text-center small">Fecha Compra</th>
                  <th className="col text-center small">Cantidad</th>
                  <th className="col text-center small">Kilos</th>
                  <th className="col text-center small">Precio</th>
                  <th className="col text-center small">Subtotal</th>
                  <th className="col text-center small">IVA</th>
                  <th className="col text-center small">ReteIVA</th>
                  <th className="col text-center small">ReteICA</th>
                  <th className="col text-center small">RetefFuente</th>
                  <th className="col text-center small">Vr. Unit. Reb.</th>
                  <th className="col text-center small">Vr. Rebate</th>
                  <th className="col text-center small">Promedio</th>
                  <th className="col text-center small">P. Total</th>
                  <th className="col text-center small">Marca</th>
                  <th className="col text-center small">Observación</th>
                </tr>
              </thead>
              <tbody>

                {comprasPagadas.length > 0 && (
                  <tr>
                    <td colSpan={COLS} className="bg-primary text-white small p-1">
                      <b>✓ COMPRAS PAGADAS ({comprasPagadas.length})</b>
                    </td>
                  </tr>
                )}
                {comprasPagadas.length === 0 && (
                  <tr>
                    <td colSpan={COLS} className="small text-muted text-center py-2">
                      Sin compras pagadas.
                    </td>
                  </tr>
                )}
                {comprasPagadas.map((row, idx) => renderFila(row, idx))}

                {comprasPagadas.length > 0 && (
                  <tr>
                    {emptyTds(2)}
                    <td className="bg-secondary text-white p-1 small text-end"><b>{format(totCantidadPag)}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{format(totKilosPag)}</b></td>
                    <td></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{format(totSubPag)}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{format(totIvaPag)}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{format(totReteivaPag)}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{format(totReteicaPag)}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{format(totRefuentePag)}</b></td>
                    <td></td>
                    <td className="bg-primary text-white p-1 small text-end"><b>{format(totRebPag)}</b></td>
                    <td></td>
                    <td className="bg-primary text-white p-1 small text-end"><b>{format(totTotalPag)}</b></td>
                    {emptyTds(2)}
                  </tr>
                )}

                {comprasPendientes.length > 0 && (
                  <tr>
                    <td colSpan={COLS} className="bg-danger text-white small p-1">
                      <b>✗ COMPRAS PENDIENTES DE PAGO ({comprasPendientes.length})</b>
                    </td>
                  </tr>
                )}
                {comprasPendientes.length === 0 && (
                  <tr>
                    <td colSpan={COLS} className="small text-muted text-center py-2">
                      Sin compras pendientes.
                    </td>
                  </tr>
                )}
                {comprasPendientes.map((row, idx) => renderFila(row, idx))}

                {comprasPendientes.length > 0 && (
                  <tr>
                    {emptyTds(2)}
                    <td className="bg-secondary text-white p-1 small text-end"><b>{format(totCantidadPend)}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{format(totKilosPend)}</b></td>
                    <td></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{format(totSubPend)}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{format(totIvaPend)}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{format(totReteivaPend)}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{format(totReteicaPend)}</b></td>
                    <td className="bg-secondary text-white p-1 small text-end"><b>{format(totRefuentePend)}</b></td>
                    <td></td>
                    <td className="bg-primary text-white p-1 small text-end"><b>{format(totRebPend)}</b></td>
                    <td></td>
                    <td className="bg-primary text-white p-1 small text-end"><b>{format(totTotalPend)}</b></td>
                    {emptyTds(2)}
                  </tr>
                )}

              </tbody>

              <tfoot>
                <tr>
                  {emptyTds(2)}
                  <td className="bg-secondary text-white p-1 small text-end"><b>{format(totCantidadPag + totCantidadPend)}</b></td>
                  <td className="bg-secondary text-white p-1 small text-end"><b>{format(totKilosPag + totKilosPend)}</b></td>
                  <td></td>
                  <td className="bg-secondary text-white p-1 small text-end"><b>{format(totSubPag + totSubPend)}</b></td>
                  <td className="bg-secondary text-white p-1 small text-end"><b>{format(totIvaPag + totIvaPend)}</b></td>
                  <td className="bg-secondary text-white p-1 small text-end"><b>{format(totReteivaPag + totReteivaPend)}</b></td>
                  <td className="bg-secondary text-white p-1 small text-end"><b>{format(totReteicaPag + totReteicaPend)}</b></td>
                  <td className="bg-secondary text-white p-1 small text-end"><b>{format(totRefuentePag + totRefuentePend)}</b></td>
                  <td></td>
                  <td className="bg-primary text-white p-1 small text-end"><b>{format(totRebPag + totRebPend)}</b></td>
                  <td></td>
                  <td className="bg-primary text-white p-1 small text-end"><strong>{format(totTotalPag + totTotalPend)}</strong></td>
                  {emptyTds(2)}
                </tr>
              </tfoot>
            </table>
          )}
        </div>
      </div>

    </div>
  );
};

export default App;
